import React, { ReactElement } from 'react';
import { Content } from './Content';

interface RegisterPageProps {}

function RegisterPage({}: RegisterPageProps): ReactElement {
  return <Content />;
}

export { RegisterPage };
